export const queryKeys = {
  all: "notifications",

  getNotifications: () => [queryKeys.all],
};
